import {FC} from 'react'
import {ExpansionPlantItem} from '../../../../@types/expansionPortfolio'
import {formatKwp, getStatusBadgeClass} from '../../utils'
import styles from '../../expansionPortfolio.module.css'

type Props = {
  plants: ExpansionPlantItem[]
  selectedId: string | null
  onSelect: (plant: ExpansionPlantItem) => void
}

const ExpansionPlantList: FC<Props> = ({plants, selectedId, onSelect}) => {
  if (!plants.length) {
    return (
      <div className={styles.emptyState}>
        <span className='fs-6 fw-semibold'>Nenhuma usina encontrada</span>
        <span className='fs-7 mt-1'>Ajuste os filtros ou aguarde os relatórios de geração/consumo.</span>
      </div>
    )
  }

  return (
    <div className={styles.listScroll}>
      {plants.map((plant) => {
        const isActive = plant.id === selectedId
        return (
          <button
            key={plant.id}
            type='button'
            className={`${styles.plantItem} ${isActive ? styles.plantItemActive : ''}`}
            onClick={() => onSelect(plant)}
          >
            <div className='d-flex justify-content-between align-items-start gap-2 mb-2'>
              <div className={styles.plantName}>
                {plant.name}
                {plant.location ? `: ${plant.location}` : ''}
              </div>
              <span className={`badge ${getStatusBadgeClass(plant.status)} text-nowrap`}>
                {plant.statusLabel}
              </span>
            </div>
            <div className={`${styles.plantMeta} d-flex justify-content-between`}>
              <span>Sugestão</span>
              <span className='fw-bold text-gray-800'>
                {plant.suggestedExpansionKwp > 0 ? formatKwp(plant.suggestedExpansionKwp) : '—'}
              </span>
            </div>
          </button>
        )
      })}
    </div>
  )
}

export {ExpansionPlantList}
